import React, { useState, useCallback } from 'react';
import type { FunctionComponent } from 'react';
import { forTemplate } from '@trello/i18n';
import { PowerUpTestIds } from '@trello/test-ids';
import { Button } from '@trello/nachos/button';
import { useDeleteSharedPluginDataMutation } from './DeleteSharedPluginDataMutation.generated';

const format = forTemplate('directory_power_up_item');
interface Props {
  disablePlugin: (e: React.SyntheticEvent<EventTarget>) => void;
  boardId: string;
  pluginId: string;
  elem: React.SyntheticEvent<EventTarget>;
}
export const DisablePluginSettings: FunctionComponent<Props> = ({
  disablePlugin,
  boardId,
  pluginId,
  elem,
}) => {
  const [checked, setChecked] = useState(false);
  const [deleteSharedPluginData] = useDeleteSharedPluginDataMutation();

  const handleDisablePlugin = useCallback(async () => {
    disablePlugin(elem);
    if (checked) {
      await deleteSharedPluginData({
        variables: {
          boardId,
          pluginId,
        },
      });
    }
  }, [boardId, pluginId, deleteSharedPluginData, checked, elem, disablePlugin]);

  return (
    <>
      <div>
        <p>{format('delete-plugin-data-explain-message')}</p>
      </div>
      <div className="check-div">
        <input
          id="checkbox_id"
          type="checkbox"
          checked={checked}
          // eslint-disable-next-line react/jsx-no-bind
          onChange={() => setChecked(!checked)}
        />
        <label htmlFor="checkbox_id">{format('delete-plugin-data')}</label>
      </div>
      <Button
        appearance="danger"
        size="fullwidth"
        onClick={handleDisablePlugin}
        data-testid={PowerUpTestIds.DisablePowerUpButton}
      >
        {format('disable-plugin-button')}
      </Button>
    </>
  );
};
